
// import './App.css';

// // App.js
// import React from "react";
// import SalesRepDashboard from "./SalesRepDashboard";

// function App() {
//   return <SalesRepDashboard />;
// }



// export default App;
// import React, { useState } from "react";
// import Login from "./login";
// import SalesRepDashboard from "./SalesRepDashboard";
// import { connectSocket } from "./socket";

// export default function App() {
//   const [loggedIn, setLoggedIn] = useState(
//     !!localStorage.getItem("token")
//   );

//   if (!loggedIn) {
//     return <Login onLogin={() => {
//       connectSocket();
//       setLoggedIn(true);
//     }} />;
//   }

//   return <SalesRepDashboard />;
// }
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./login";
import SalesRepDashboard from "./SalesRepDashboard";
import AdminPanel from "./adminPannel";
import { connectSocket } from "./socket";

export default function App() {
  const loggedIn = !!localStorage.getItem("token");

  return (
    <BrowserRouter>
      <Routes>
        {/* ADMIN — no login */}
        <Route path="/admin" element={<AdminPanel />} />

        {/* SALES FLOW */}
        <Route
          path="/"
          element={
            loggedIn ? (
              <SalesRepDashboard />
            ) : (
              <Login
                onLogin={() => {
                  connectSocket();
                  window.location.reload();
                }}
              />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
